import React from 'react';
import PropTypes from 'prop-types';
import CalendarUtils from 'services/CalendarUtils';
import ListBadge from 'components/Common/ListBadge';
import PatientUtils from 'services/PatientUtils';
import { useAppSelector } from 'careand-redux/store';
import StaffUtils from 'services/StaffUtils';
import CPPUtils from 'services/CPPUtils';

const dateFormat = 'Do MMMM YYYY';

const PrescriptionBadge = ({ item, patient, children, showPhysician = false }) => {
  const physician = useAppSelector((state) => state.physicians.byId[item.physician_id]);
  return (
    <>
      {!!patient && (
        <ListBadge
          className="prescription-badge"
          title={PatientUtils.getName(patient, undefined, false)}
          firstLine={getTitle(item)}
          secondLine={getDate(item, showPhysician ? physician : undefined)}
        >
          {children}
        </ListBadge>
      )}
      {!patient && (
        <ListBadge
          title={getTitle(item)}
          className="prescription-badge"
          firstLine={getMedicationsDescription(item)}
          secondLine={getDate(item, showPhysician ? physician : undefined)}
        >
          {children}
        </ListBadge>
      )}
    </>
  );
};

function getDate(prescription, physician) {
  let physicianText = physician ? `${StaffUtils.getName(physician)} - ` : '';
  return `${physicianText}${CalendarUtils.format(prescription.date, dateFormat)}`.trim();
}

function getMedicationsDescription(prescription) {
  let medications = prescription.medications;
  let medicationsText = '';

  if (medications) {
    if (medications.length === 1) {
      medicationsText = CPPUtils.getPrescriptionMedicationSummary(medications[0], true);
    } else {
      medicationsText = medications
        .map((medication) => {
          return medication.name;
        })
        .join(', ');
    }
  }
  return medicationsText.trim();
}

function getTitle(prescription) {
  let medications = prescription.medications;
  if (medications)
    return medications.length === 1 ? medications[0].name : medications.length + ' Medications';
  return '';
}

PrescriptionBadge.propTypes = {
  item: PropTypes.object.isRequired,
};

export default PrescriptionBadge;
